/* GooseBumps — vanilla, no dependencies. */
(() => {
  document.documentElement.classList.add('js');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const say = (m) => { const l = $('#Live'); if (l) l.textContent = m; };

  /* ---- dialogs ---- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open]');
    if (open) { e.preventDefault(); $('#' + open.dataset.open)?.showModal(); return; }
    if (e.target.closest('[data-close]')) { e.target.closest('dialog')?.close(); return; }
    if (e.target.matches('dialog')) e.target.close(); // backdrop
  });

  /* ---- cart ---- */
  const SECTION = 'cart-drawer';
  const paint = (sections) => {
    const html = sections?.[SECTION];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = $('#CartInner', doc), cur = $('#CartInner');
    if (next && cur) cur.replaceWith(next);
    const n = next?.dataset.count ?? 0;
    $$('[data-cart-count]').forEach((b) => { b.textContent = n; b.hidden = +n === 0; });
    document.dispatchEvent(new CustomEvent('gb:cart', { detail: { count: +n } }));
  };
  const post = (url, body, json) => fetch(url, {
    method: 'POST',
    headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
    body,
  }).then(async (r) => { const d = await r.json(); if (!r.ok) throw new Error(d.description || d.message || 'Something went wrong'); return d; });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    if (!fd.get('selling_plan')) fd.delete('selling_plan');
    fd.append('sections', SECTION);
    fd.append('sections_url', location.pathname);
    const btns = [...$$('button[type=submit]', form), ...(form.id ? $$(`button[form="${form.id}"]`) : [])];
    btns.forEach((b) => b.setAttribute('data-busy', ''));
    const err = $('[data-form-error]', form);
    if (err) err.hidden = true;
    try {
      const d = await post(window.GB.routes.cartAdd, fd);
      if (e.submitter?.hasAttribute('data-buy-now')) { location.href = '/checkout'; return; }
      paint(d.sections);
      if (form.hasAttribute('data-quiet')) {
        btns.forEach((b) => { b.disabled = true; $('[data-atc-label]', b).textContent = 'Added'; });
      } else $('#CartDrawer')?.showModal();
      say('Added to your bag');
    } catch (ex) {
      if (err) { err.textContent = ex.message; err.hidden = false; }
      say(ex.message);
    } finally { btns.forEach((b) => b.removeAttribute('data-busy')); }
  });

  const changeLine = async (line, quantity) => {
    const scope = $('#CartInner');
    scope?.setAttribute('aria-busy', 'true');
    try {
      const d = await post(window.GB.routes.cartChange, JSON.stringify({ line, quantity, sections: [SECTION], sections_url: location.pathname }), true);
      paint(d.sections);
      if (document.body.classList.contains('tpl-cart')) location.reload();
    } catch (ex) { say(ex.message); scope?.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (b) { e.preventDefault(); changeLine(+b.dataset.line, +b.dataset.lineQty); }
  });

  /* ---- purchase option drives the sticky price ---- */
  const syncPrice = () => {
    const p = $('.plan input:checked')?.closest('.plan').querySelector('[data-plan-price]');
    if (p) $$('[data-sticky-atc] [data-price]').forEach((x) => { x.textContent = p.textContent; });
  };
  syncPrice();
  document.addEventListener('change', (e) => { if (e.target.matches('.plan input')) syncPrice(); });

  /* ---- variant picker ---- */
  $$('[data-product]').forEach((root) => {
    const data = $('[data-variants]', root);
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const form = $('form[data-cart-form]', root);
    const update = () => {
      const opts = $$('.opt', root).map((f) => $('input:checked', f)?.value);
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      $$('.opt', root).forEach((f, i) => { const s = $('legend span', f); if (s) s.textContent = opts[i]; });
      const btns = [...$$('[data-atc]', root), ...$$('[data-atc]')];
      if (!v) { btns.forEach((b) => { b.disabled = true; $('[data-atc-label]', b).textContent = 'Unavailable'; }); return; }
      $('input[name=id]', form).value = v.id;
      const fmt = (c) => root.dataset.moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(c % 100 ? 2 : 0));
      $$('[data-price]').forEach((p) => { p.textContent = fmt(v.price); });
      $$('[data-compare]').forEach((p) => { p.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; });
      btns.forEach((b) => { b.disabled = !v.available; $('[data-atc-label]', b).textContent = v.available ? b.dataset.label : 'Sold out'; });
      $$('.plan input', root).forEach((r) => {
        const a = r.value && v.selling_plan_allocations.find((x) => x.selling_plan_id == r.value);
        if (a) $('[data-plan-price]', r.closest('.plan')).textContent = fmt(a.price);
      });
      syncPrice();
      history.replaceState({}, '', `${location.pathname}?variant=${v.id}`);
      if (v.featured_media) $(`[data-media="${v.featured_media.id}"]`, root)?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    };
    root.addEventListener('change', (e) => { if (e.target.closest('.opt')) update(); });
  });

  /* ---- formula pills: hover on desktop, tap everywhere ---- */
  const closePills = (except) => $$('.pill.is-open').forEach((p) => {
    if (p !== except) { p.classList.remove('is-open'); $('[data-pill]', p).setAttribute('aria-expanded', 'false'); }
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pill]');
    if (!b) { if (!e.target.closest('.pop')) closePills(); return; }
    const p = b.parentElement;
    closePills(p);
    b.setAttribute('aria-expanded', p.classList.toggle('is-open'));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePills(); });

  /* ---- swipe dots: gallery + rails ---- */
  $$('[data-rail]').forEach((rail) => {
    const dots = rail.parentElement.querySelector('[data-dots]');
    const kids = [...rail.children];
    if (!dots || kids.length < 2) return;
    dots.innerHTML = kids.map((_, i) => `<button type="button" aria-label="Go to item ${i + 1}"${i ? '' : ' aria-current="true"'}></button>`).join('');
    const btns = [...dots.children];
    btns.forEach((b, i) => b.addEventListener('click', () => rail.scrollTo({ left: kids[i].offsetLeft - kids[0].offsetLeft, behavior: 'smooth' })));
    const io = new IntersectionObserver((es) => es.forEach((en) => {
      if (en.isIntersecting) { const i = kids.indexOf(en.target); btns.forEach((b, j) => (j === i ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current'))); }
    }), { root: rail, threshold: 0.6 });
    kids.forEach((k) => io.observe(k));
  });

  /* ---- show more ---- */
  $$('[data-clamp]').forEach((box) => {
    const btn = box.parentElement.querySelector('[data-more]');
    if (!btn) return;
    if (box.scrollHeight <= box.clientHeight + 8) { box.classList.add('is-open'); btn.hidden = true; return; }
    btn.addEventListener('click', () => {
      const open = box.classList.toggle('is-open');
      $('span', btn).textContent = open ? 'Show less' : 'Show more';
      btn.setAttribute('aria-expanded', open);
    });
  });

  /* ---- sticky add to bag ---- */
  const sticky = $('[data-sticky-atc]'), anchor = $('[data-atc-anchor]');
  if (sticky && anchor) {
    new IntersectionObserver(([en]) => sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(anchor);
  }

  /* ---- reveal ---- */
  const rv = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); rv.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
  $$('[data-reveal]').forEach((n) => rv.observe(n));

  /* ---- collection sort ---- */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-sort]')) { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); location.href = u; }
  });
})();

/* product tables: drop-downs on desktop, always open on mobile */
(function(){
  var m=window.matchMedia('(min-width:990px)');
  /* tables and accordions sit under the gallery on desktop */
  var moved=[].map.call(document.querySelectorAll('[data-move]'),function(n){var h=document.createComment('');n.before(h);return {n:n,h:h}});
  function place(){moved.forEach(function(o){if(m.matches){document.querySelector('[data-slot="'+o.n.dataset.move+'"]').append(o.n)}else{o.h.after(o.n)}})}
  function set(){place();document.querySelectorAll('[data-drop]').forEach(function(d){d.open=!m.matches||d.dataset.drop==='open'})}
  set();m.addEventListener('change',set);
})();
